import * as actions from "../actions/loadOrder";
import { setSafe } from "../util/storeHelper";
export const loReducer = {
    reducers: {
        [actions.setLoadOrder]: (state, payload) => setSafe(state, [payload.id], payload.order),
    },
    defaults: {},
    verifiers: {},
};
